import Codex from "./lib_js/codex.mjs";
export default new Codex();
